export default class ProductFilter {
    constructor() {
        $('.filter__input, .filter__line-input').on('change', () => {
            let priceGroup = $('.filter__input:checked').attr('id').replace('c-', '');
            this.applyPrice(priceGroup);
            //this.applySection();
        });

        document.querySelectorAll('.mobile-price-filter .ui-dropdown-menu__item').forEach(el => el.addEventListener('click', this.onMobilePriceClick.bind(this)));
        this.checkHash();
    }

    // A lot of legacy
    applyPrice(priceGroup) {
        priceGroup += '';

        let productListElement = document.querySelector('.itemlist');
        productListElement.classList.add('itemlist--filtered');

        productListElement.querySelectorAll('.item').forEach((el) => {
            el.style.display = el.dataset.priceCategory === priceGroup || priceGroup === '0' ? '' : 'none';
        });

        $(`.filter__item .filter__link[for="c-${priceGroup}"]`).siblings('input[type="radio"]').prop('checked', true);

        document.querySelectorAll(`.mobile-price-filter .ui-dropdown-menu__item`).forEach((el) => el.classList.remove('ui-dropdown-menu__item--active'));
        document.querySelector(`.mobile-price-filter .ui-dropdown-menu__item[data-code="${priceGroup}"]`).classList.add('ui-dropdown-menu__item--active');
    }

    // Seems to be unused
    applySection() {
        let checkedSections = [];

        $('.filter__line-input:checked').each(function () {
            checkedSections.push(parseInt($(this).attr('id').replace('f-', '')));
        });

        if (checkedSections.length > 0) {
            $('.itemlist .item').each(function () {
                var secArr = $(this).data('section');
                var hideFlag = true;
                secArr.forEach(function (item) {
                    if (checkedSections.indexOf(item) !== -1) {
                        hideFlag = false;
                    }
                });
                if (hideFlag) {
                    $(this).hide();
                }

            });
        }
    }

    onMobilePriceClick(e) {
        e.preventDefault();
        this.applyPrice(e.currentTarget.dataset.code);
    }

    checkHash() {
        if (document.location.hash.length === 0) {
            return;
        }

        const params = new URLSearchParams(document.location.hash.slice(1));

        if (!params.get('prices')) {
            return;
        }

        this.applyPrice(params.get('prices'));
    }
}